import React, { use } from "react";
import { useState, useRef, useEffect } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, Tabs, Tab, Menu, MenuItem
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { MdOutlineFilterAlt } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import Select from "react-select";
import CustomButton from "components/Button";
import AddDesignEngineer from "./addEngineering";
import EditDesignEng from "./editEngineering";
import ViewDesignEng from "./viewEngineering";
import { componentOptions, stageOptions, blockOptions } from "helpers/designEngineeringOptions";
import { useLazyGetAllDesignEngQuery, useLazyGetDesignEngByIdQuery, useGetDesignEngStatusCountQuery, useLazyGetExportAllDesignEngQuery } from "store/slices/apis/designEngineeringSlice";
import { useParams } from "react-router-dom";
import CustomPagination from "components/CustomPagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WbsTreeView from "view/dashboard/wbsTreeView";
import { usePermission } from "hooks/usePermission";
import { ENGINEERING_ACCESS, ENGINEERING_CREATE, ENGINEERING_EDIT, ENGINEERING_VIEW } from "helpers/permissionConfig";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";
import { MdOutlineFileDownload } from "react-icons/md";
import { DEFAULT_DATE_FORMAT } from "config";
import useExcelExport from "hooks/useExcelExport";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// const gfcApprovalStatusOptions = [
//     { label: "NA", value: "NA" },
//     { label: "Pending", value: "Pending" },
//     { label: "Received", value: "Received" },
// ];

const EngineeringTracker = () => {
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = useRef(null);
    const [isAddDesignEng, setIsAddDesignEng] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState(null);

    const [assetAnchorEl, setAssetAnchorEl] = useState(null);
    const [assetFullPath, setAssetFullPath] = useState("");

    const createAccess = usePermission(ENGINEERING_CREATE)
    const editAccess = usePermission(ENGINEERING_EDIT);
    // const deleteAccess = usePermission(ENGINEERING_);
    const viewAccess = usePermission(ENGINEERING_VIEW);

    const [trigger, { data: designList, isFetching }] = useLazyGetAllDesignEngQuery()
    const [getDesignById, { data: designByIdData, isLoading: isDesignByIdLoading }] = useLazyGetDesignEngByIdQuery();
    const { data: countData, refetch: refetchCounts } =
        useGetDesignEngStatusCountQuery({
            ProjectId: projectId
        });

    const module = "DesignAndEngineeringTracker";

    const { data: documentTypeOptionsRes } = useGetMasterDataQuery({ module: module, category: 'DocumentType', ProjectId: projectId });
    const documentTypeOptionsData = documentTypeOptionsRes?.data || [];
    const documentTypeOptions = mapAndSortAlphabetically(documentTypeOptionsData);

    const { data: consultantOptionsRes } = useGetMasterDataQuery({ module: module, category: 'Consultant', ProjectId: projectId });
    const consultantOptionsData = consultantOptionsRes?.data || [];
    const consultantOptions = (consultantOptionsData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: disciplineOptionsRes } = useGetMasterDataQuery({ module: module, category: 'Discipline', ProjectId: projectId });
    const disciplineOptionsData = disciplineOptionsRes?.data || [];
    const disciplineOptions = mapAndSortAlphabetically(disciplineOptionsData);

    const { data: statusOptionsRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const statusOptionsData = statusOptionsRes?.data || [];
    const statusOptions = (statusOptionsData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: approvalStatusOptionsRes } = useGetMasterDataQuery({ module: module, category: 'IEApprovalStatus', ProjectId: projectId });
    const approvalStatusOptionsData = approvalStatusOptionsRes?.data || [];
    const approvalStatusOptions = (approvalStatusOptionsData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: gfcApprovalStatusOptionsRes } = useGetMasterDataQuery({ module: module, category: 'GFCApprovalStatus', ProjectId: projectId });
    const gfcApprovalStatusOptionsData = gfcApprovalStatusOptionsRes?.data || [];
    const gfcApprovalStatusOptions = (gfcApprovalStatusOptionsData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: engineeringData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    const counts = React.useMemo(() => {
        if (!countData?.data || !Array.isArray(countData.data)) {
            return {
                received: 0,
                pending: 0,
                planned: 0,
                inProgress: 0,
                completed: 0,
                resubmission: 0,
                notApplicable: 0,
                total: 0
            };
        }

        let received = 0;
        let pending = 0;
        let planned = 0;
        let inProgress = 0;
        let completed = 0;
        let resubmission = 0;
        let notApplicable = 0;
        let total = 0;

        countData.data.forEach(item => {
            const status = item.status;
            const count = item.count || 0;

            if (status === "Received") received = count;
            else if (status === "Planned") planned = count;
            else if (status === "In Progress") inProgress = count;
            else if (status === "Pending") pending = count;
            else if (status === "Completed") completed = count;
            else if (status === "Resubmission Required") resubmission = count;
            else if (status === "Not Applicable") notApplicable = count;


            total += count;
        });

        return {
            received,
            pending,
            planned,
            inProgress,
            completed,
            resubmission,
            notApplicable,
            total
        };
    }, [countData]);

    const [filters, setFilters] = useState({
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        ProjectId: projectId,
        SearchTerm: "",
    });

    const { handleExport, isExporting } = useExcelExport({ exportHook: useLazyGetExportAllDesignEngQuery, fileName: "Engineering_Tracker_Data" });

    const exportEngineeringData = (rows) =>
        rows.map((row, index) => ({
            "S.No": index + 1,
            "ID": row.customId || "-",
            "Asset": row.projectCode || "-",
            "Document Type": row.designType || "-",
            "Discipline": row.discipline || "-",
            "Consultant": row.consultant || "-",
            "Drawing Title": row.title || "-",
            "Drawing Number": row.drgNo || "-",
            "Latest Revision Date": row.lastSubmissionDate && moment(row.lastSubmissionDate).isValid()
                ? moment(row.lastSubmissionDate).format(DEFAULT_DATE_FORMAT)
                : '-',
            "Latest Revision No": row.lastRevisionNo || "-",
            "GFC Approval Status": row.gfcApprovalStatus || "-",
            "GFC Approval Date": row.gfcApprovalDate && moment(row.gfcApprovalDate).isValid()
                ? moment(row.gfcApprovalDate).format(DEFAULT_DATE_FORMAT)
                : '-',
            "Status": row.status || "-",
            "Target Date": row.targetDate && moment(row.targetDate).isValid()
                ? moment(row.targetDate).format(DEFAULT_DATE_FORMAT)
                : '-',
            "IE Approval Date": row.ieApprovalDate && moment(row.ieApprovalDate).isValid()
                ? moment(row.ieApprovalDate).format(DEFAULT_DATE_FORMAT)
                : '-',
            "IE Approval Status": row.ieApprovalStatus || "-",
        }));

    useEffect(() => {
        trigger(filters);
    }, []);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };

    const handleMenuEdit = () => {
        if (menuRow) {
            handleEditDesignEng(menuRow);
        }
        handleMenuClose();
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        const statusMap = {
            0: "",
            1: "Planned",
            2: "In Progress",
            3: "Completed",
            4: "Resubmission Required",
            5: "Not Applicable"
        };

        const updatedFilters = {
            ...filters,
            PageNumber: 1,
            Status: statusMap[newValue] || ""
        };

        setFilters(updatedFilters);
        setPageNumber(1);
        trigger(updatedFilters);
    };


    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
            SearchTerm: "",
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedFilters = {
            ...filters,
            [name]: value,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        if (filterType === "wbsName") {
            updatedFilters.wbsName = "";
            updatedFilters.SubDesign1 = "";
            updatedFilters.SubDesign2 = "";
            updatedFilters.SubDesign3 = "";
            updatedFilters.SubDesign4 = "";
            updatedFilters.SubDesign5 = "";
        }

        setFilters(updatedFilters);
        setTabValue(0)
        trigger(updatedFilters);
        setPageNumber(1);
    };

    const handleAddDesignEng = () => {
        setIsAddDesignEng((prev) => !prev);
        if (isAddDesignEng) {
            refetchCounts();
            trigger(filters);
        }
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleEditDesignEng = async (row) => {
        try {

            const result = await getDesignById(row?.designTrackerId).unwrap();
            setSelectedData(result?.data || row);
            setIsEdit((prev) => !prev);
            if (!isEdit) {
                refetchCounts();
            }


        } catch (error) {

            console.error('Error fetching design by ID:', error);
            setIsEdit((prev) => !prev);
            setSelectedData(row);
        }
    };

    const handleEditClose = () => {
        setIsEdit((prev) => !prev);
        setSelectedData(null);
    };




    const handleViewClick = async (row) => {
        try {

            const result = await getDesignById(row.designTrackerId).unwrap();

            setViewData(result.data || row);


            setIsView(true);
        } catch (error) {
            console.error('Error fetching design by ID:', error);

            setViewData(row);
            setIsView(true);
        }
    };


    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
    };

    const getAvatarColor = (status, targetDate) => {
        const colors = ["#388E3C", "#FF7578", "#e86100", "#d3d3d3 |"];

        if (!targetDate) return colors[0];

        const today = new Date();
        const target = new Date(targetDate);


        today.setHours(0, 0, 0, 0);
        target.setHours(0, 0, 0, 0);

        if (status === 'Received' && today <= target) {
            return colors[0];
        }
        if (status === 'Pending' && today <= target) {
            return colors[2];
        }
        if (status === 'Pending' && today > target) {
            return colors[1];
        }


        return colors[3];
    };

    const getTabCount = (tabLabel) => {
        switch (tabLabel) {
            case "All": return counts.total;
            case "Planned": return counts.planned;
            case "In Progress": return counts.inProgress;
            case "Completed": return counts.completed;
            case "Received": return counts.received;
            case "Pending": return counts.pending;
            case "Approved": return counts.approved;
            case "Resubmission Required": return counts.resubmission;
            case "Not Applicable": return counts.notApplicable;
            default: return 0;
        }
    };

    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };

    const getLastSegment = (path) => {
        if (!path) return "";
        const parts = path.split(">").map(p => p.trim());
        return parts[parts.length - 1] || "";
    };

    const openAssetMenu = (event, fullPath) => {
        event.stopPropagation();
        setAssetAnchorEl(event.currentTarget);
        setAssetFullPath(fullPath);
    };

    const closeAssetMenu = () => {
        setAssetAnchorEl(null);
        setAssetFullPath("");
    };

    const columns = [

        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>}
                </>
            ),
        },
        {
            name: "ID",
            field: "customId",
            width: "70px",
            sticky: true,
        },

        // {
        //     name: "Component",
        //     field: "component",
        //     width: "200px",
        //     sticky: true,
        //     renderer: (row) => (
        //         <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        //             {/* <Avatar
        //                 sx={{
        //                     width: 30,
        //                     height: 30,
        //                     bgcolor: getAvatarColor(row.status, row.targetDate),
        //                     color: "#fff",
        //                     fontSize: "14px",
        //                     fontWeight: "bold",
        //                     textTransform: "uppercase",
        //                 }}
        //             >
        //                 {row?.component?.[0] || "?"}
        //             </Avatar> */}
        //             {row?.component}
        //         </Box>
        //     ),
        // },
        {
            name: "Asset",
            field: "projectCode",
            width: "250px",
            renderer: (row) => {
                const fullPath = row.projectCode;
                if (!fullPath) return null;

                const lastValue = getLastSegment(fullPath);

                return (
                    <>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <IconButton
                                size="small"
                                onClick={(e) => openAssetMenu(e, fullPath)}
                            >
                                <MoreHorizIcon fontSize="small" />
                            </IconButton>

                            <Typography
                                sx={{
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    //maxWidth: 180,
                                }}
                            >
                                {lastValue}
                            </Typography>
                        </Box>
                    </>
                );
            },
        },
        {
            name: "Document Type",
            field: "designType"
        },
        {
            name: "Discipline",
            field: "discipline",
        },
        {
            name: "Consultant",
            field: "consultant",

        },
        // {
        //     name: "Block",
        //     field: "block"
        // },
        // {
        //     name: "Stage",
        //     field: "stage",
        // },
        {
            name: "Drawing Title",
            field: "title",
            width: "140px",
            renderer: (row) => highlightText(row.title, searchTerm),

        },
        {
            name: "Drawing Number",
            field: "drgNo",
            renderer: (row) => highlightText(row.drgNo, searchTerm),
        },
        {
            name: "Latest Revision Date",
            field: "lastSubmissionDate",
            renderer: (row) => (
                row?.lastSubmissionDate ? moment(row.lastSubmissionDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Latest Revision No",
            field: "lastRevisionNo",
        },
        {
            name: "GFC Approval Status",
            field: "gfcApprovalStatus",
            renderer: (row) => (
                <StatusBadge status={row.gfcApprovalStatus} />
            )
        },
        {
            name: "GFC Approval Date",
            field: "gfcApprovalDate",
            renderer: (row) => (
                row?.gfcApprovalDate ? moment(row.gfcApprovalDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Status",
            field: "status",
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Target Date",
            field: "targetDate",
            renderer: (row) => (
                row?.targetDate ? moment(row.targetDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "IE Approval Date",
            field: "ieApprovalDate",
            renderer: (row) => (
                row?.ieApprovalDate ? moment(row.ieApprovalDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "IE Approval Status",
            field: "ieApprovalStatus",
            renderer: (row) => (
                <StatusBadge status={row.ieApprovalStatus} />
            )
        },
    ];

    const mapWbsIdsToSubcats = (wbsIdsPath) => {
        const ids = wbsIdsPath
            ? wbsIdsPath.split(",").map(id => id.trim())
            : [];

        return {
            SubDesign1: ids[0] ?? "",
            SubDesign2: ids[1] ?? "",
            SubDesign3: ids[2] ?? "",
            SubDesign4: ids[3] ?? "",
            SubDesign5: ids[4] ?? "",
        };
    };

    return (
        <>
            <TrackerPageHeader title="Engineering Tracker" description="Monitor drawings, reviews, approvals, and engineering deliverables.">
                <ProjectLastUpdatedOn date={engineeringData?.engineering} />
            </TrackerPageHeader>
            <Grid container spacing={2} sx={{ p: 2 }}>

                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "2px solid #ECECEC",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "30px",
                                },
                            }}
                        >
                            {["All", "Planned", "In Progress", "Completed"].map((label, index) => {
                                const count = getTabCount(label);
                                return (
                                    <Tab
                                        key={index}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                        fontFamily: "Outfit, sans-serif"
                                                    }}
                                                >
                                                    {label}
                                                </Typography>
                                                {index != 0 &&
                                                    <Chip
                                                        label={count}
                                                        sx={{
                                                            height: "20px",
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            lineHeight: 1,
                                                            backgroundColor: "#E5E9EB",
                                                            color: "#5F5F5F",
                                                        }}
                                                    />
                                                }

                                            </Box>
                                        }
                                        sx={{
                                            textTransform: "none",
                                            minWidth: "auto",
                                            paddingBottom: "14px",
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                        }}
                                    />
                                );
                            })}
                        </Tabs>
                        {createAccess &&
                            <CustomButton
                                label="Add Drawings to DCI"
                                startIcon={<FaPlus />}
                                color="primary"
                                onClick={handleAddDesignEng}
                                sx={{
                                    backgroundColor: "#2563EB",
                                    fontFamily: 'Outfit',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '100%',
                                    letterSpacing: '0px',
                                }}
                            />
                        }

                    </Box>
                </Grid>

                <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 6 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >

                                {filters.Discipline && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Discipline:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Discipline}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Discipline')}
                                    />
                                )}

                                {filters.Status && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Status}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Status')}
                                    />
                                )}

                                {filters.IEApprovalStatus && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>IE Approval Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.IEApprovalStatus}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('IEApprovalStatus')}
                                    />
                                )}

                                {filters.GfcApprovalStatus && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>GFC Approval Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.GfcApprovalStatus}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('GfcApprovalStatus')}
                                    />
                                )}

                                {/* {filters.Block && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Block:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Block}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Block')}
                                    />
                                )} */}

                                {/* {filters.TargetDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Target Date:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.TargetDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('TargetDate')}
                                    />
                                )} */}
                                {filters.FromDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>From Date:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.FromDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('FromDate')}
                                    />
                                )}
                                {filters.ToDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>To Date:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.ToDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('ToDate')}
                                    />
                                )}
                                {/* {filters.Component && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Component:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Component}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Component')}
                                    />
                                )} */}
                                {filters.Consultant && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Consultant:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Consultant}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Consultant')}
                                    />
                                )}
                                {/* {filters.Stage && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Stage:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Stage}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Stage')}
                                    />
                                )} */}

                                {filters.DesignType && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Document Tpye:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.DesignType}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('DesignType')}
                                    />
                                )}

                                {filters.wbsName && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Asset:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.wbsName}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete("wbsName")}
                                    />
                                )}
                            </Stack>
                        </Grid>

                        <Grid size={{ md: 4, sm: 6 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { md: "row", xs: "column" },
                                    alignItems: { md: "center", xs: "flex-start" },
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >

                                <TextField
                                    placeholder="Search By Drawing Title, Drawing No."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: { md: '320px', xs: "auto" },
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-root': { borderRadius: '3px', minHeight: '36px', fontSize: '13px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />

                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>

                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box
                                                        sx={{
                                                            maxHeight: "50vh",   // popup max height
                                                            overflowY: "auto",
                                                            overflowX: "hidden",
                                                            p: 2,
                                                            borderRadius: "3px",
                                                        }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            <Grid size={{ xs: 12, md: 6 }}>
                                                                <Grid container spacing={2}>
                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            //mt: 1,
                                                                            mb: 1,
                                                                            fontSize: "16px",
                                                                            fontWeight: 500,
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            //color: "#0A0A0C"
                                                                            lineHeight: '100%',
                                                                        }}>
                                                                            Select Asset
                                                                        </Typography>

                                                                        <WbsTreeView
                                                                            projectId={projectId}
                                                                            parentId="683"
                                                                            onSelect={function (node) {
                                                                                const subDesigns = mapWbsIdsToSubcats(node.idPath);
                                                                                setFilters(prev => ({
                                                                                    ...prev,
                                                                                    ...subDesigns,
                                                                                    wbsName: node?.name ?? "",
                                                                                    //wbsNamePath: node.fullPath,
                                                                                    //wbsIdsPath: node.idPath,
                                                                                }));

                                                                            }}
                                                                        />

                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid size={{ xs: 12, md: 6 }}>
                                                                <Grid container spacing={2}>
                                                                    {/* <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Component</Typography>
                                                                <Select
                                                                    name="Component"
                                                                    options={componentOptions}
                                                                    placeholder="Select Component"
                                                                    onChange={(option) => handleSelectChange(option, "Component")}
                                                                    value={componentOptions.find(option => option.value === filters.Component) || null}
                                                                />
                                                            </Grid> */}

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select Document Type</Typography>
                                                                        <Select
                                                                            name="DesignType"
                                                                            options={documentTypeOptions}
                                                                            placeholder="Select Document Type"
                                                                            onChange={(option) => handleSelectChange(option, "DesignType")}
                                                                            value={documentTypeOptions.find(option => option.value === filters.DesignType) || null}
                                                                        />
                                                                    </Grid>

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select Consultant</Typography>
                                                                        <Select
                                                                            name="Consultant"
                                                                            options={consultantOptions}
                                                                            placeholder="Select Consultant"
                                                                            onChange={(option) => handleSelectChange(option, "Consultant")}
                                                                            value={consultantOptions.find(option => option.value === filters.Consultant) || null}
                                                                        />
                                                                    </Grid>
                                                                    {/* <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Stage</Typography>
                                                                <Select
                                                                    name="Stage"
                                                                    options={stageOptions}
                                                                    placeholder="Select Stage"
                                                                    onChange={(option) => handleSelectChange(option, "Stage")}
                                                                    value={stageOptions.find(option => option.value === filters.Stage) || null}
                                                                />
                                                            </Grid> */}

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select Discipline</Typography>
                                                                        <Select
                                                                            name="Discipline"
                                                                            options={disciplineOptions}
                                                                            placeholder="Select Discipline"
                                                                            onChange={(option) => handleSelectChange(option, "Discipline")}
                                                                            value={disciplineOptions.find(option => option.value === filters.Discipline) || null}
                                                                        />
                                                                    </Grid>

                                                                    {/* <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Block</Typography>
                                                                <Select
                                                                    name="Block"
                                                                    options={blockOptions}
                                                                    placeholder="Select Block"
                                                                    onChange={(option) => handleSelectChange(option, "Block")}
                                                                    value={blockOptions.find(option => option.value === filters.Block) || null}
                                                                />
                                                            </Grid> */}

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select Status</Typography>
                                                                        <Select
                                                                            name="Status"
                                                                            options={statusOptions}
                                                                            placeholder="Select Status"
                                                                            onChange={(option) => handleSelectChange(option, "Status")}
                                                                            value={statusOptions.find(option => option.value === filters.Status) || null}
                                                                        />
                                                                    </Grid>

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select IE Approval Status</Typography>
                                                                        <Select
                                                                            name="IEApprovalStatus"
                                                                            options={approvalStatusOptions}
                                                                            placeholder="Select IE Approval Status"
                                                                            onChange={(option) => handleSelectChange(option, "IEApprovalStatus")}
                                                                            value={approvalStatusOptions.find(option => option.value === filters.IEApprovalStatus) || null}
                                                                        />
                                                                    </Grid>

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>Select GFC Approval Status</Typography>
                                                                        <Select
                                                                            name="GfcApprovalStatus"
                                                                            options={gfcApprovalStatusOptions}
                                                                            placeholder="Select GFC Approval Status"
                                                                            onChange={(option) => handleSelectChange(option, "GfcApprovalStatus")}
                                                                            value={gfcApprovalStatusOptions.find(option => option.value === filters.GfcApprovalStatus) || null}
                                                                        />
                                                                    </Grid>

                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>From Date</Typography>
                                                                        <TextField
                                                                            type="date"
                                                                            name="FromDate"
                                                                            // onBlur={handleBlur}
                                                                            onChange={handleDateChange}
                                                                            value={filters.FromDate ? moment(filters.FromDate).format("YYYY-MM-DD") : ""}
                                                                            onClick={(e) => {
                                                                                // Trigger the native date picker
                                                                                const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                                if (input) input.showPicker?.();
                                                                            }}
                                                                            fullWidth
                                                                            sx={{
                                                                                // ...rightTextStyle,
                                                                                "& input::-webkit-calendar-picker-indicator": {
                                                                                    display: "none",
                                                                                    WebkitAppearance: "none",
                                                                                },
                                                                                "& input[type='date']": {
                                                                                    appearance: "none",
                                                                                    WebkitAppearance: "none",
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    "& fieldset": {
                                                                                        border: "none",
                                                                                    },
                                                                                },
                                                                            }}
                                                                            InputProps={{
                                                                                startAdornment: (
                                                                                    <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                    >
                                                                                        {calenderSVG}
                                                                                    </Box>
                                                                                ),
                                                                                sx: {
                                                                                    backgroundColor: "#E7E7EB",
                                                                                    height: "40px",
                                                                                    width: { xs: "100%", md: "100%" },
                                                                                    borderRadius: "3px",
                                                                                },
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid size={12}>
                                                                        <Typography sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}>To Date</Typography>
                                                                        <TextField
                                                                            type="date"
                                                                            name="ToDate"
                                                                            // onBlur={handleBlur}
                                                                            onChange={handleDateChange}
                                                                            value={filters.ToDate ? moment(filters.ToDate).format("YYYY-MM-DD") : ""}
                                                                            onClick={(e) => {
                                                                                // Trigger the native date picker
                                                                                const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                                if (input) input.showPicker?.();
                                                                            }}
                                                                            fullWidth
                                                                            sx={{
                                                                                // ...rightTextStyle,
                                                                                "& input::-webkit-calendar-picker-indicator": {
                                                                                    display: "none",
                                                                                    WebkitAppearance: "none",
                                                                                },
                                                                                "& input[type='date']": {
                                                                                    appearance: "none",
                                                                                    WebkitAppearance: "none",
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    "& fieldset": {
                                                                                        border: "none",
                                                                                    },
                                                                                },
                                                                            }}
                                                                            InputProps={{
                                                                                startAdornment: (
                                                                                    <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                                    >
                                                                                        {calenderSVG}
                                                                                    </Box>
                                                                                ),
                                                                                sx: {
                                                                                    backgroundColor: "#E7E7EB",
                                                                                    height: "40px",
                                                                                    width: { xs: "100%", md: "100%" },
                                                                                    borderRadius: "3px",
                                                                                },
                                                                            }}
                                                                        />
                                                                    </Grid>

                                                                    <Grid size={12}>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "flex-end",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <Button onClick={handleReset}
                                                                                sx={{
                                                                                    textTransform: "none",
                                                                                    color: "#F15744",
                                                                                    fontSize: "14px",
                                                                                    lineHeight: "100%",
                                                                                    fontFamily: "Outfit, sans-serif",
                                                                                    borderRadius: "3px",
                                                                                    fontWeight: 500,
                                                                                    px: "20px",
                                                                                    py: "15px",
                                                                                }}>
                                                                                Reset
                                                                            </Button>
                                                                            <Button
                                                                                type="button"
                                                                                onClick={handleApplyFilters}
                                                                                variant="contained"
                                                                                sx={{
                                                                                    backgroundColor: "#2563EB",
                                                                                    borderRadius: "3px",
                                                                                    textTransform: "none",
                                                                                    fontWeight: 500,
                                                                                    fontSize: "14px",
                                                                                    lineHeight: "100%",
                                                                                    fontFamily: "Outfit, sans-serif",
                                                                                    color: "#FFFFFF",
                                                                                    px: "20px",
                                                                                    py: "15px",
                                                                                }}
                                                                            >
                                                                                Apply
                                                                            </Button>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                <IconButton onClick={() =>
                                    handleExport(
                                        filters,
                                        exportEngineeringData
                                    )
                                } disabled={isExporting}>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>

                                <IconButton onClick={() => trigger(filters)}>
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={12}>
                    <TableComponent
                        data={designList?.data || []}
                        isLoading={isFetching}
                        columns={columns}
                        order={sortOrder}
                        orderBy={sortBy}
                        createSortHandler={handleRequestSort}
                    />


                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess &&
                            <MenuItem
                                onClick={handleMenuView}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <LuEye size={16} style={{ color: "#4B5563" }} />
                                <span>View</span>
                            </MenuItem>
                        }
                        {editAccess &&
                            <MenuItem
                                onClick={handleMenuEdit}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <EditIcon style={{ width: 14, height: 14 }} />
                                <span>Edit</span>
                            </MenuItem>
                        }
                    </Menu>

                    <Menu
                        anchorEl={assetAnchorEl}
                        open={Boolean(assetAnchorEl)}
                        onClose={closeAssetMenu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                        PaperProps={{
                            sx: {
                                width: "auto",
                                maxWidth: "none",
                            },
                        }}
                    >
                        <MenuItem sx={{
                            whiteSpace: "nowrap",
                        }}>
                            <Typography sx={{ fontSize: 13 }}>
                                {assetFullPath}
                            </Typography>
                        </MenuItem>
                    </Menu>

                    <CustomPagination
                        totalCount={designList?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid>
            </Grid>
            {isAddDesignEng && <AddDesignEngineer open={isAddDesignEng} handleClose={handleAddDesignEng} refetchCounts={refetchCounts} />}
            {isEdit && <EditDesignEng open={isEdit} handleClose={handleEditClose} rowData={selectedData} refetchCounts={refetchCounts} />}
            {isView && (
                <ViewDesignEng
                    open={isView}
                    handleClose={handleViewClose}
                    rowData={viewData}
                    isLoading={isDesignByIdLoading}
                />
            )}
        </>
    );
}

export default EngineeringTracker;
